var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AnalyticsSubPage,{attrs:{"title":"Analytics","icon":"chart-pie","css-class":"analytics-homepage","default-label":"Summary","get-sheet-config":_setup.getSheetConfig}},[_c(_setup.SnapshotMetrics,{ref:"snapshotRef"}),_c(_setup.AdoptionMetrics),_c(_setup.AppLoginsMetrics),_c(_setup.AppFeaturesMetrics)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }